module.exports = __webpack_public_path__ + "img/NIKKO-IMG-04.7b0a7b68.jpg";